import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { HighlightOff } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useStyles } from "../../../../util/TableStyles";
import { FeatureService } from "../../../../services/FeatureService";

moment.locale('es');

export const useBenefitsTable = (changeAlert: ChangeAlertCallbackType, removeFeature) => {
    const clasess = useStyles();
    const [data, setData] = useState([]);
    const [uuid, setUuid] = useState('');
    const [loading, setLoading] = useState(false);
    const featureService = useRef<FeatureService>();
	const [tabActive, setTabActive] = useState("features");

    const [tabs] = useState([
		{ key: "features", title: "Production" },
		{ key: "blacklist", title: "Blacklist" },
	]);

    const saveData = async (result) => {
        setLoading(true);       
        setData(result.content);
        setUuid(result.customerUuid);
        setLoading(false);
    };

    const getData = async () => {
        setLoading(true);
        let payload = {
            data: {
                customer_uuid: uuid,
            }
        }
        const response = await featureService.current.featureGet(payload);
        setData(response.data?.widget[0].data.content || []);
        setLoading(false);
    };

    const changeTab = (tab: string) => {
		setTabActive(tab);
	};

	function findActiveTab(item) {
		return item.key === tabActive;
	}

    useEffect(() => {
        featureService.current = new FeatureService(changeAlert)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const calculateColumns = useMemo(() => {
        const columns = []
        if(tabActive === 'blacklist'){
            columns.push(
                { selector: (row) => row.feature_uuid, name: "UUID", wrap: true, width: "30%", sortable: false },
                { selector: (row) => row.feature_name, name: "Nombre", wrap: true, width: "20%", sortable: false },
                { selector: (row) => row.active ? 'Activo' : 'Inactivo', name: "Estatus", wrap: true, width: "15%", sortable: false },
                { selector: (row) => moment(row.udate).format("LLL"), name: "Fecha actualización", wrap: true, width: "20%", sortable: false },
            )
        } else {
            columns.push(
                { selector: (row) => row.uuid, name: "UUID", wrap: true, width: "25%", sortable: false },
                { selector: (row) => row.feature_name, name: "Nombre", wrap: true, width: "25%", sortable: false },
                { selector: (row) => row.feature_description, name: "Descripción", wrap: true, width: "25%", sortable: false },
                { selector: (row) => row.feature_status, name: "Estatus", wrap: true, width: "15%", sortable: false }
            )
        }
        if(tabActive !== 'blacklist'){
            columns.push(
                { cell: (row) => {
                    return (
                      <IconButton title="Remover beneficio" className={clasess.buttonAdd} onClick={removeFeature.bind(this, row, uuid)}>
                        <HighlightOff />
                      </IconButton>
                    )},
                   width:"7%", wrap: true, sortable: true
                }
            )
        }

        return columns
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuid, tabActive])

    return { columns: calculateColumns, data, loading, uuid, tabs, tabActive, findActiveTab, changeTab, saveData, getData }

}
